var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDtf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4805 39.504H47.8636V100.142H23.4805V39.504Z",
    fill: "#57ED57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.063 39.504H47.8636V100.142H42.063V39.504Z",
    fill: "#2DD62D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7408 24.671H85.2591V30.1314H39.7408V24.671Z",
    fill: "#F89B00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6368 24.671H85.2591V30.1314H81.6368V24.671Z",
    fill: "#E68207"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2017 39.729H101.52V100.142H76.2017V39.729Z",
    fill: "#57ED57"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0292 39.729H101.519V100.142H98.0292V39.729Z",
    fill: "#2DD62D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7368 39.5039H105.263V43.6743H19.7368V39.5039Z",
    fill: "#909CD1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6766 67.7599H103.323V72.1113H21.6766V67.7599Z",
    fill: "#909CD1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2222 28.5117H79.7774V100.142H45.2222V28.5117Z",
    fill: "#FDC72E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1517 28.5117H79.7777V100.142H75.1517V28.5117Z",
    fill: "#F9AC00"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7368 95.3428H105.263V100.142H19.7368V95.3428Z",
    fill: "#909CD1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.363 28.5117H81.6367V33.3111H43.363V28.5117Z",
    fill: "#E68207"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2222 62.1511H79.7775V66.5025H45.2222V62.1511Z",
    fill: "#909CD1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6687 82.6515H94.6279V95.3427H86.6687V82.6515Z",
    fill: "#F3F3FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0629 78.0034H67.9369V95.3427H57.0629V78.0034Z",
    fill: "#F3F3FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.519 39.5039H105.263V43.6743H101.519V39.5039Z",
    fill: "#7986BF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.519 95.3428H105.263V100.142H101.519V95.3428Z",
    fill: "#7986BF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M101.519 67.7599H103.323V72.1113H101.519V67.7599Z",
    fill: "#7986BF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1512 62.1511H79.7772V66.5025H75.1512V62.1511Z",
    fill: "#7986BF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5411 28.5117H81.6368V33.3111H77.5411V28.5117Z",
    fill: "#D76A00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1917 41.5715C57.9023 41.5715 55.2108 44.263 55.2108 47.5524V53.8906H67.1726V47.5524C67.1726 44.2628 64.4812 41.5715 61.1917 41.5715Z",
    fill: "#F9AC00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5007 41.5715C59.2112 41.5715 56.5198 44.263 56.5198 47.5524V53.8906H68.4816V47.5524C68.4816 44.2628 65.7901 41.5715 62.5007 41.5715Z",
    fill: "#F3F3FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.548 41.0116V47.0602H68.7567V49.1547H63.548V54.4539H61.4535V49.1547H54.2457V47.0602H61.4535V41.0116H63.548Z",
    fill: "#FDC72E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2101 78.0034H57.063V95.3427H55.2101V78.0034Z",
    fill: "#F9AC00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0012 79.0507C53.4228 79.0507 52.954 78.5819 52.954 78.0034C52.954 77.425 53.4228 76.9562 54.0012 76.9562H69.6579C70.2364 76.9562 70.7052 77.425 70.7052 78.0034C70.7052 78.5819 70.2364 79.0507 69.6579 79.0507H54.0012Z",
    fill: "#F89B00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5035 50.4751C86.5989 50.4751 84.2227 52.8513 84.2227 55.7559V61.3523H94.7843V55.7559C94.7843 52.8513 92.408 50.4751 89.5035 50.4751Z",
    fill: "#2DD62D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6491 50.4751C87.7445 50.4751 85.3683 52.8513 85.3683 55.7559V61.3523H95.9299V55.7559C95.9299 52.8513 93.5537 50.4751 90.6491 50.4751Z",
    fill: "#F3F3FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.7255 55.199H89.6016V50.1587H91.6963V55.199H96.2636V57.2935H91.6963V61.6719H89.6016V57.2935H83.7255V55.199Z",
    fill: "#57ED57"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1815 82.6515H86.669V95.3427H85.1815V82.6515Z",
    fill: "#2DD62D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4278 83.6986C83.8493 83.6986 83.3805 83.2298 83.3805 82.6514C83.3805 82.0729 83.8493 81.6041 84.4278 81.6041H95.8872C96.4656 81.6041 96.9345 82.0729 96.9345 82.6514C96.9345 83.2298 96.4656 83.6986 95.8872 83.6986H84.4278Z",
    fill: "#29B933"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3717 82.6516H38.3309V95.3428H30.3717V82.6516Z",
    fill: "#F3F3FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8844 82.6516H30.3719V95.3428H28.8844V82.6516Z",
    fill: "#2DD62D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1308 83.6986C27.5523 83.6986 27.0835 83.2298 27.0835 82.6514C27.0835 82.0729 27.5523 81.6041 28.1308 81.6041H39.5902C40.1687 81.6041 40.6375 82.0729 40.6375 82.6514C40.6375 83.2298 40.1687 83.6986 39.5902 83.6986H28.1308Z",
    fill: "#29B933"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2065 50.4751C30.3019 50.4751 27.9257 52.8513 27.9257 55.7559V61.3523H38.4873V55.7559C38.4873 52.8513 36.111 50.4751 33.2065 50.4751Z",
    fill: "#2DD62D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3521 50.4751C31.4475 50.4751 29.0713 52.8513 29.0713 55.7559V61.3523H39.6329V55.7559C39.6329 52.8513 37.2567 50.4751 34.3521 50.4751Z",
    fill: "#F3F3FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4285 55.199H33.3048V50.1587H35.3993V55.199H39.9666V57.2935H35.3993V61.6719H33.3048V57.2935H27.4285V55.199Z",
    fill: "#57ED57"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M42.063 39.5039H45.2222V43.6743H42.063V39.5039Z",
    fill: "#7986BF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0631 67.7599H45.2223V72.1113H42.0631V67.7599Z",
    fill: "#7986BF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0631 95.3428H45.2223V100.142H42.0631V95.3428Z",
    fill: "#7986BF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1519 95.3428H79.7778V100.142H75.1519V95.3428Z",
    fill: "#7986BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtf);
export default __webpack_public_path__ + "static/media/dtf.54e1cf112618d2f9b746e18bfb9d78c5.svg";
export { ForwardRef as ReactComponent };